/**
 * Categories for El Detective. Each category is a *theme* over the same
 * logic engine: names, place, the "object" at the centre of the case, and a
 * verb that reads well as "«Name» {verb} {object}."
 */

export const CATEGORIES = [
  {
    id: 'logica',
    label: 'Lógica fría',
    emoji: '🧠',
    blurb: 'Deducción pura. Nada de pistas falsas de más.',
    party: false,
    place: 'la biblioteca cerrada de Blackwood',
    object: 'el manuscrito original',
    verb: 'sustrajo',
    names: ['Aurora', 'Bruno', 'Carmen', 'Damián', 'Elena', 'Fabián', 'Gloria', 'Hugo'],
    facts: [
      'La puerta estaba cerrada con llave por dentro.',
      'La ventana daba a un patio sin salida.',
      'Nadie entró ni salió después de la cena.',
    ],
  },
  {
    id: 'copas',
    label: 'Noche de Copas',
    emoji: '🍸',
    blurb: 'Para el bar o la previa. Rápido, con trampa y risa.',
    party: true,
    place: 'la última ronda de la noche',
    object: 'el último trago',
    verb: 'se tomó',
    names: ['Sofi', 'Lucas', 'Male', 'Nico', 'Vale', 'Toto', 'Cami', 'Juli'],
    facts: [
      'La barra ya estaba cerrada cuando esto pasó.',
      'Alguien apagó la música antes de la cuenta.',
      'El hielo se había terminado hace rato.',
    ],
  },
  {
    id: 'historia',
    label: 'Misterio histórico',
    emoji: '🏛️',
    blurb: 'Robos de época. Deducción con sabor a museo.',
    party: false,
    place: 'el museo de antigüedades',
    object: 'la corona real',
    verb: 'sustrajo',
    names: ['Isabel', 'Rodrigo', 'Beatriz', 'Alfonso', 'Leonor', 'Sancho', 'Urraca', 'Felipe'],
    facts: [
      'Las vitrinas seguían intactas al amanecer.',
      'Los guardias cambiaron turno justo antes del hallazgo.',
      'El inventario se había firmado la tarde anterior.',
    ],
  },
  {
    id: 'ciencia',
    label: 'Ciencia',
    emoji: '🔬',
    blurb: 'Algo salió mal en el laboratorio. ¿Quién fue?',
    party: false,
    place: 'el laboratorio del sótano',
    object: 'la muestra congelada',
    verb: 'alteró',
    names: ['Ada', 'Niels', 'Marie', 'Erwin', 'Lise', 'Kurt', 'Rosalind', 'Emmy'],
    facts: [
      'El registro de temperatura no marcó ninguna alarma.',
      'El acceso se abre solo con huella del equipo.',
      'La centrífuga quedó apagada al terminar el turno.',
    ],
  },
  {
    id: 'mundo',
    label: 'Jet set',
    emoji: '✈️',
    blurb: 'Un robo en la sala VIP. Acertijos con jet lag.',
    party: false,
    place: 'la sala VIP del aeropuerto',
    object: 'el pasaporte sellado',
    verb: 'sustrajo',
    names: ['Mika', 'Devi', 'Omar', 'Sasha', 'Noor', 'Kai', 'Ileana', 'Tariq'],
    facts: [
      'El vuelo se retrasó dos horas por la niebla.',
      'El control de pasaportes cerró a medianoche.',
      'La puerta de embarque cambió a última hora.',
    ],
  },
]

export function getCategory(id) {
  return CATEGORIES.find((c) => c.id === id) || CATEGORIES[0]
}
